import React, { Component } from 'react';

class ModulesModal extends Component {

    render() {
        const { action, adminUsersModel, checkbox, editMode, SaveModules, CloseModulesModal } = this.props;
        
        let arrayModules = []
        for (const key in adminUsersModel.itemsDashboard) {
            if (Object.hasOwnProperty.call(adminUsersModel.itemsDashboard, key)) {
                const element = adminUsersModel.itemsDashboard[key];
                if(element.grp && element.tit !== 'Monedero Electrónico'){
                    arrayModules.push(element);
                }
            }
        }

        const allActive = arrayModules.length > 0 && arrayModules.every(m => m.active);
        const someActive = arrayModules.some(m => m.active) && !allActive;

        const allWrite = arrayModules.length > 0 && arrayModules.every(m => m.Wr);
        const someWrite = arrayModules.some(m => m.Wr) && !allWrite;

        const isDisabled = action === 2 && !editMode;

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="modulesModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="modulesModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Módulos</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseModulesModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <thead className="table-header">
                                                    <tr>
                                                        <td className="sticky-header table-header-yellow ">Título</td>
                                                        <td className="sticky-header table-header-yellow">
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                <input type="checkbox" disabled={isDisabled} checked={allActive} ref={el => { if (el) el.indeterminate = someActive; }} style={{ width: '15px', height: '15px', cursor: isDisabled ? 'not-allowed' : 'pointer' }} onChange={() => checkbox.selectAll(arrayModules, !allActive)} title={allActive ? 'Desactivar todos' : 'Activar todos'}/>
                                                                Activo
                                                            </div>
                                                        </td>
                                                        <td className="sticky-header table-header-yellow">
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                <input type="checkbox" disabled={isDisabled} checked={allWrite} ref={el => { if (el) el.indeterminate = someWrite; }} style={{ width: '15px', height: '15px', cursor: isDisabled ? 'not-allowed' : 'pointer' }} onChange={() => checkbox.writeAll(arrayModules, !allWrite)} title={allWrite ? 'Quitar escritura a todos' : 'Dar escritura a todos'}/>
                                                                Escritura
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!arrayModules && 
                                                        arrayModules.map((module, index) => {
                                                            return(
                                                                <tr key={index}>                                                            
                                                                    <td>{module.tit}</td>
                                                                    <td className="sticky-column">
                                                                        <input 
                                                                            type="checkbox"
                                                                            disabled={isDisabled}
                                                                            checked={module.active}
                                                                            style={{minWidth: '100%', width:'15px', height:'15px'}}
                                                                            onChange={() => checkbox.selectOne(module, 1)}/>
                                                                    </td>
                                                                    <td className="sticky-column">
                                                                        <input 
                                                                            type="checkbox"
                                                                            disabled={isDisabled}
                                                                            checked={module.Wr}
                                                                            style={{minWidth: '100%', width:'15px', height:'15px'}}
                                                                            onChange={() => checkbox.writeAccess(module)}/>
                                                                    </td>
                                                                </tr>                                  
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseModulesModal}>
                                    Cerrar
                            </button>
                            {action === 1 && !editMode &&
                                <button type="button" className="btn botonCorrect"
                                    onClick={SaveModules}>
                                        Guardar
                                </button>
                            }
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" 
                                    onClick={SaveModules}>
                                        Actualizar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModulesModal;